<template>
  <v-card v-if="snackbar.text">
    <v-snackbar
      v-model="snackbar.text"
      :bottom="'bottom'"
      :color="'error'"
      :multi-line="'multi-line'"
      :right="'right'"
      :timeout="3000"
    >
      {{ snackbar.text }}
      <v-btn dark text @click="resetSnackBar">
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Snackbar",
  computed: {
    ...mapState({
      snackbar: state => state.toggle.snackBar
    })
  },
  methods: {
    resetSnackBar() {
      this.$store.dispatch("resetSnackBar");
    }
  }
};
</script>
